import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
    selector: 'app-button-tags',
    templateUrl: './button-tags.component.html',
    styleUrls: ['./button-tags.component.css'],
})
export class ButtonTagsComponent implements OnInit {
    @Input() buttonList: any[] = []
    @Input() selectedTags: string[] = []
    @Input() isMultiple = true
    @Input() readonly = false

    @Output() _click: EventEmitter<string> = new EventEmitter<string>()

    constructor() {
    }

    ngOnInit() {
    }

    toggleTag(item) {
        console.log(this.readonly)
        if (this.readonly) {
            return
        }
        if (!this.selectedTags) {
            this.selectedTags = []
        }
        const found = this.selectedTags.findIndex((e) => {
            return e == item._id
        })
        if (found == -1) {
            if (!this.isMultiple) {
                this.selectedTags = []
            }
            this.selectedTags.push(item._id)
        } else {
            this.selectedTags.splice(found, 1)
        }
        this._click.emit(item._id)
    }

    checkActiveTag(item) {

        return this.selectedTags && this.selectedTags.findIndex((e) => {
            return e === item._id
        }) !== -1
    }

    checkDisableTag(item) {
        return this.selectedTags && this.selectedTags.findIndex((e) => {
            return e === item._id
        }) == -1 && this.readonly == true
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/o-button/button-tags/button-tags.component.ts